import { render, staticRenderFns } from "./IndividualLender.vue?vue&type=template&id=31432438&scoped=true&"
import script from "./IndividualLender.vue?vue&type=script&lang=ts&"
export * from "./IndividualLender.vue?vue&type=script&lang=ts&"
import style0 from "./IndividualLender.vue?vue&type=style&index=0&id=31432438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31432438",
  null
  
)

export default component.exports